/** HTTP statuses that mean the session is invalid and must be cleared. */
export function isSessionInvalidStatus(status) {
  return status === 401 || status === 403;
}

const ME_MAX_ATTEMPTS = 3;

export function meRetryDelayMs(attempt) {
  return 400 * (attempt + 1);
}

/**
 * Load /api/auth/me with short retries for transient network/5xx failures.
 * Only treats 401/403 as a hard session invalidation.
 *
 * @param {() => Promise<{ data: any }>} getMe
 */
export async function loadSessionUser(getMe, { maxAttempts = ME_MAX_ATTEMPTS, delayFn = meRetryDelayMs } = {}) {
  let lastError;
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    try {
      const response = await getMe();
      return { ok: true, data: response.data };
    } catch (error) {
      lastError = error;
      const status = error.response?.status;
      if (isSessionInvalidStatus(status)) {
        return { ok: false, authInvalid: true, error };
      }
      if (attempt < maxAttempts - 1) {
        await new Promise((resolve) => setTimeout(resolve, delayFn(attempt)));
      }
    }
  }
  return { ok: false, authInvalid: false, error: lastError };
}
